import { Row } from "antd";
import FooterBottomBar from "./FooterBottomBar/FooterBottomBar";
import FooterBrand from "./FooterBrand/FooterBrand";
import FooterNavLinks from "./FooterNavLinks/FooterNavLinks";
import FooterSocialLinks from "./FooterSocialLinks/FooterSocialLinks";
import { FooterWrapper, AccentDivider } from "./Footer.styled";

export const Footer = () => {
  return (
    <FooterWrapper>
      <Row
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
        style={{ width: "100%", paddingLeft: "5%", paddingRight: "2%", paddingTop: "5%" }}
      >
        <FooterBrand />
        <FooterSocialLinks />
      </Row>

      <FooterNavLinks />

      <AccentDivider />

      <FooterBottomBar />
    </FooterWrapper>
  );
};
